import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
// 按域名控制菜单可见性与路由访问，配置写在路由 meta 上（hiddenDomains）。

/**
 * 归一化域名字符串：去端口、转小写、去 www. 前缀。
 * @param {string} [host=""] 原始域名（可含端口或 www. 前缀）
 * @returns {string} 归一化后的域名，如 "GC.JoinMC.cn:443" -> "gc.joinmc.cn"
 */
const normalizeHost = (host = "") => String(host).toLowerCase().split(":")[0].replace(/^www\./, "");

/**
 * 获取当前页面所在域名（已归一化）。
 * @returns {string} 当前域名，如 "joinmc.cn"
 */
export const getCurrentHost = () => normalizeHost(window.location.hostname);

/**
 * 判断当前域名是否命中给定的隐藏域名列表。
 * 命中规则：完全相等，或当前域名是其子域（如 gc.joinmc.cn 命中 joinmc.cn）。
 * @param {string[]} hiddenDomains 隐藏域名列表；非数组或为空时返回 false
 * @returns {boolean} 命中返回 true，否则 false
 */
export function isHiddenOnCurrentDomain(hiddenDomains) {
  if (!Array.isArray(hiddenDomains) || !hiddenDomains.length) return false;
  const host = getCurrentHost();
  return hiddenDomains.some(domain => {
    const target = normalizeHost(domain);
    return Boolean(target) && (host === target || host.endsWith(`.${target}`));
  });
}

/**
 * 判断路由是否应在当前域名下隐藏。
 * 依据路由 meta.hiddenDomains 配置：声明了 hiddenDomains 且当前域名命中时，
 * 该路由的菜单入口隐藏、且禁止直接访问。
 * @param {object} [meta] 路由的 meta 对象
 * @param {string[]} [meta.hiddenDomains] 隐藏域名列表
 * @returns {boolean} 应隐藏返回 true，否则 false
 */
export function isMenuHiddenByDomain(meta) {
  return isHiddenOnCurrentDomain(meta?.hiddenDomains);
}

/**
 * 路由级守卫：命中隐藏域名时重定向到 404，避免菜单已隐藏但仍可通过 URL 进入。
 * @param {import('vue-router').Route} to 目标路由
 * @param {import('vue-router').Route} from 来源路由
 * @param {import('vue-router').NavigationGuardNext} next 继续导航的回调
 * @returns {void}
 */
export function blockHiddenDomain(to, from, next) {
  if (isMenuHiddenByDomain(to.meta)) {
    next("/404");
    return;
  }
  next();
}